import axios from "axios";
import { BaseResponse } from "../models/base";

export const signupApi = async (
  email: string,
  name: string,
  companyName: string,
  countryCode: string,
  mobileNo: string,
  password: string,
  countryName: string,
  countryId?: string
): Promise<any> => {
  try {
    const payload = {
      email: email,
      firstName: name,
      lastName: "",
      companyName: companyName,
      countryCode: countryCode,
      mobileNumber: mobileNo,
      password: password,
      countryName,
      ...(countryId && { countryId }),
    };
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/company/profile/create/client`,
      payload
    );
    if (response.data.statusCode === "OK") {
      return response.data;
      // setSuccess(true);
    } else {
      return response.data;
    }
  } catch (error:any) {
    console.error("Error during login:", error);
    return error.response.data;
    return false;
  }
};

export const forgotPassword = async (email: string): Promise<any> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/user/forget-password`,
      {
        email: email,
      }
    );

    if (response.data.statusCode === "OK") {
      return response;
      // setSuccess(true);
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error during login:", error);
    return false;
  }
};

export const resetClientPassword = async (
  oldPassword: string,
  newPassword: string
): Promise<BaseResponse<boolean> | undefined> => {
  try {
    const response = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/company/profile/update/password`,
      {
        oldPassword: oldPassword,
        newPassword: newPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error during login:", error);
  }
};

export const verifyLinkApi = async (token: string): Promise<any> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/company/profile/verify/client`,
      {
        token: token,
      }
    );

    if (response.data.statusCode === "OK") {
      return response;
      // setSuccess(true);
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error during login:", error);
    return false;
  }
};

export const verifyResetOtp = async (
  email: string,
  otp: string
): Promise<any> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/user/verify-otp`,
      { email: email, otp: otp }
    );

    if (response?.data?.data) {
      localStorage.setItem("tempToken", response?.data?.data?.token);
      return response;
      // setSuccess(true);
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error during login:", error);
    return false;
  }
};

export const resetPasswordApi = async (newPassword: string): Promise<any> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/user/reset-password-by-id`,
      { newPassword: newPassword },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("tempToken"),
        },
      }
    );

    if (response.data.statusCode === "OK") {
      return response;
      // setSuccess(true);
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error during login:", error);
    return false;
  }
};
